import { Directive, ElementRef, HostBinding } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[rafFormSubmitted]',
})
export class FormSubmittedDirective {
  @HostBinding('class.formSubmitted') get isSubmitted(): boolean {
    return this.fgd?.submitted;
  }

  constructor(private element: ElementRef, private fgd: FormGroupDirective) {}
}
